import PurchaseConfirmationDialog from '@apps/guest/packages/layout-engine/widgets/Custom/components/TravelMap/components/PurchaseConfirmationDialog/PurchaseConfirmationDialog';
import { usePurchaseContextIdFromLocation } from '@apps/registry/common/utils/dropship';
import { Box, Flex, useDisclosure } from '@withjoy/joykit';
import React, { useContext, useEffect, useState } from 'react';
import { AnalyticsContext, useHistory } from '@shared/core';
import { useHotelRoutePaths } from '../HotelBooking/HotelBooking.routes';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

const NUITEE_BG_BIG = 'https://withjoy.com/assets/public/nuitee-clone-large.jpg';
const NUITEE_BG_SMALL = 'https://withjoy.com/assets/public/nuitee-bg-small.png';

export const AccommodationsOnRegistryConfirmation: React.FC<{ eventHandle: string; eventId: string }> = ({ eventHandle }) => {
  const [isPurchaseConfirmationOpen, setIsPurchaseConfirmationOpen] = useState(false);
  const history = useHistory();
  const hotelRoute = useHotelRoutePaths();
  const { isOpen: isPurchaseConfirmationDialogOpen, onClose: onPurchaseConfirmationClose } = useDisclosure({
    isOpen: isPurchaseConfirmationOpen,
    onClose: () => {
      history.push(
        hotelRoute.hotelSearch.buildRelativeUrl(eventHandle, {
          utm_medium: 'web',
          utm_source: 'confirmation_registry_purchase',
          utm_campaign: 'confirmation_registry_purchase_next_steps',
        }),
      );
    },
  });

  const analytics = useContext(AnalyticsContext);

  const purchaseId = usePurchaseContextIdFromLocation();

  const handleTelemetry = useEventCallback((name: string, action: string) => {
    analytics.track({
      category: 'guest.purchase',
      action,
      extraInfo: { name, pageType: 'nuiteeClone' },
    });
  }, []);

  useEffect(() => {
    handleTelemetry('registryPurchaseConfirmation', 'PageViewed');
  }, [handleTelemetry]);

  useEffect(() => {
    if (purchaseId) {
      setIsPurchaseConfirmationOpen(true);
    }
  }, [purchaseId]);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100vw"
    >
      <Box
        as="img"
        width="100%"
        filter="blur(4px)"
        src={NUITEE_BG_SMALL}
        display={{ _: 'block', sm: 'none' }}
      />
      <Box
        as="img"
        width="100%"
        maxWidth={1000}
        filter="blur(4px)"
        src={NUITEE_BG_BIG}
        display={{ _: 'none', sm: 'block' }}
      />
      <PurchaseConfirmationDialog
        isOpen={isPurchaseConfirmationDialogOpen}
        onClose={onPurchaseConfirmationClose}
      />
    </Flex>
  );
};
